<template>
  <div>
    <!-- 顶部面包屑 -->
    <breadcrumbs></breadcrumbs>

    <!-- 员工信息卡片 -->
    <!-- <el-card class="employee-info-card" shadow="never">
      <div class="employee-info">
        <div class="info-item">
          <label>员工姓名：</label>
          <span>{{ employeeInfo.name || 'xxx' }}</span>
        </div>
        <div class="info-item">
          <label>员工电话：</label>
          <span>{{ employeeInfo.phone || '18200003779' }}</span>
        </div>
        <div class="info-item">
          <label>员工绩效(用户实付总额)：</label>
          <span class="performance-amount">{{ employeeInfo.totalPerformance || 'xxxx' }}</span>
        </div>
      </div>
    </el-card> -->
     <div
        class="topReturnLink w60 fw-600 color0063ea f16 pdb-10 cursor mgb-15"
        @click="$router.go(-1)"
      >
        <i class="el-icon-arrow-left fw-600"></i>
        返回
      </div>
    <el-descriptions
      class="margin-top"
      title=""
      :column="3"
      size="medium"
      border
    >
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-user"></i>
          员工姓名：
        </template>
        {{ employeeInfo.name }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-mobile-phone"></i>
          员工电话：
        </template>
        {{ employeeInfo.phone }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-tickets"></i>
          员工绩效(用户实付总额):
        </template>
        {{ employeeInfo.totalPrice - employeeInfo.refundPrice }}元
      </el-descriptions-item>
    </el-descriptions>
    <div style="margin: 5px 0; height: 1px"></div>

    <!-- 分区查询 -->
    <el-form
      :inline="true"
      ref="searchForm"
      :model="searchForm"
      class="search-form"
    >
      <el-form-item label="分区查询：">
        <el-select
          v-model="searchForm.regionId"
          filterable
          placeholder="请选择分区"
        >
          <el-option
            v-for="item in zoneList"
            :key="item.id"
            :label="item.regionName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="getAreaList()">查询</el-button>
        <el-button  @click="getAreaListre()">重置</el-button>
      </el-form-item>
    </el-form>
    <!-- 分区绩效表格 -->
    <el-table
      :data="tableData"
      border
      stripe
      style="width: 100%; margin-top: 15px"
      v-loading="loading"
    >
      <el-table-column prop="index" label="序号" width="60" align="center">
        <template slot-scope="scope">
          {{ (currentPage - 1) * pageSize + scope.$index + 1 }}
        </template>
      </el-table-column>

      <el-table-column
        prop="regionName"
        label="分区名称"
        min-width="120"
        align="center"
      ></el-table-column>

      <el-table-column
        prop="userPackagePrice"
        label="用户套餐实付(元)"
        min-width="140"
        align="center"
      >
        <template slot-scope="scope">
          <span class="amount-text">{{ scope.row.userPackagePrice }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="activityPackagePrice"
        label="活动套餐实付(元)"
        min-width="140"
        align="center"
      >
        <template slot-scope="scope">
          <span class="amount-text">{{ scope.row.activityPackagePrice }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="totalPrice"
        label="套餐总实付(元)"
        min-width="120"
        align="center"
      >
        <template slot-scope="scope">
          <span class="amount-text">{{ scope.row.totalPrice }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="refundPrice"
        label="退款金额(元)"
        min-width="110"
        align="center"
      >
        <template slot-scope="scope">
          <span class="amount-text refund-text">{{
            scope.row.refundPrice
          }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="totalPrice"
        label="实际销售(元)"
        min-width="110"
        align="center"
      >
        <template slot-scope="scope">
          <span class="amount-text sales-text">{{
            scope.row.totalPrice - scope.row.refundPrice
          }}</span>
        </template>
      </el-table-column>

      <el-table-column label="操作" width="100" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="text"
            style="color: var(--accent)"
            @click="handleAreaDetail(scope.row)"
          >
            详情
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      layout="prev, pager, next, sizes, total"
      :total="total"
      style="text-align: center; margin-top: 20px"
    >
    </el-pagination>

    <!-- 分区详情弹窗 -->
    <el-dialog
      title="分区详情"
      :visible.sync="areaDetailDialogVisible"
      width="70%"
      :close-on-click-modal="false"
    >
      <div v-if="currentAreaDetail">
        <el-descriptions :column="2" border>
          <el-descriptions-item label="分区名称">{{
            currentAreaDetail.regionName
          }}</el-descriptions-item>
          <el-descriptions-item label="员工姓名">{{
            employeeInfo.name
          }}</el-descriptions-item>
          <el-descriptions-item label="用户套餐实付"
            >{{ currentAreaDetail.userPackageAmount }}元</el-descriptions-item
          >
          <el-descriptions-item label="活动套餐实付"
            >{{
              currentAreaDetail.activityPackageAmount
            }}元</el-descriptions-item
          >
          <el-descriptions-item label="套餐总实付"
            >{{ currentAreaDetail.totalPackageAmount }}元</el-descriptions-item
          >
          <el-descriptions-item label="退款金额"
            >{{ currentAreaDetail.refundAmount }}元</el-descriptions-item
          >
          <el-descriptions-item label="实际销售金额">
            <span class="sales-highlight"
              >{{ currentAreaDetail.actualSalesAmount }}元</span
            >
          </el-descriptions-item>
          <el-descriptions-item label="统计时间">{{
            currentAreaDetail.statisticsTime || "2024-01-01"
          }}</el-descriptions-item>
        </el-descriptions>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="areaDetailDialogVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import breadcrumbs from "@/components/breadcrumbs.vue";

export default {
  components: {
    breadcrumbs,
  },
  data() {
    return {
      loading: false,
      zoneList: [],

      employeeInfo: {
        id: null,
        name: "",
        phone: "",
        totalPerformance: 0,
      },

      searchForm: {
        regionId: "",
      },

      tableData: [],

      currentPage: 1,
      pageSize: 10,
      total: 0,

      areaDetailDialogVisible: false,
      currentAreaDetail: null,
    };
  },

  created() {
    // this.getEmployeeInfo();
    this.employeeInfo = JSON.parse(this.$route.query.data);
    this.getPullzone();
    // console.log(this.employeeInfo);
    this.getAreaList();

  },

  methods: {
    getPullzone() {
      this.$api.marketing.allZonePull().then((res) => {
        console.log(res, "res111");

        this.zoneList = res.data || [];
      });
    },
    // 获取员工信息
    getEmployeeInfo() {
      // const employeeId = this.$route.params.id || this.$route.query.id;
      // if (employeeId) {
      //   // 调用获取员工信息的API
      //   this.$api.marketing
      //     .employee_detail({ id: employeeId })
      //     .then((res) => {
      //       this.employeeInfo = res.data;
      //     })
      //     .catch((error) => {
      //       console.error("获取员工信息失败:", error);
      //     });
      // }
    },
    getAreaListre(){
      this.searchForm = {
        regionId: "",
      };
      this.currentPage = 1;
      this.getAreaList();
    },
    // 获取分区绩效列表
    getAreaList() {
      this.loading = true;

      const params = {
        phone: this.employeeInfo.phone,
        regionId: this.searchForm.regionId,
        page: this.currentPage,
        pageSize: this.pageSize,
      };

      this.$api.marketing
        .region_list(params)
        .then((res) => {
          this.tableData = res.data.rows || [];
          this.total = res.data.total || 0;
          this.loading = false;
        })
        .catch((error) => {
          console.error("获取分区绩效列表失败:", error);
          this.loading = false;
          this.$message.error("获取分区绩效列表失败");
        });
    },

    // 查看分区详情
    handleAreaDetail(row) {
       this.$router.push({
        path: "/staff/sellTeam/teamDetail2info",
        query: { data: JSON.stringify(row)  },
      });
      return
      this.currentAreaDetail = { ...row };
      this.areaDetailDialogVisible = true;
    },

    // 分页大小改变
    handleSizeChange(newSize) {
      this.pageSize = newSize;
      this.currentPage = 1;
      this.getAreaList();
    },

    // 当前页改变
    handleCurrentChange(newPage) {
      this.currentPage = newPage;
      this.getAreaList();
    },
  },
};
</script>
<style lang="scss" scoped>
// 员工信息卡片
.employee-info-card {
  margin-bottom: 20px;
  background-color: var(--card-bg);
  border: 1px solid var(--table-border);

  ::v-deep .el-card__body {
    padding: 20px;
  }
}

.employee-info {
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-wrap: wrap;
  gap: 20px;

  .info-item {
    display: flex;
    align-items: center;
    font-size: 16px;

    label {
      font-weight: 600;
      color: var(--text-sub);
      margin-right: 8px;
    }

    span {
      color: var(--text-muted);
    }
  }

  .performance-amount {
    color: var(--accent) !important;
    font-weight: 600;
    font-size: 18px;
  }
}

// 查询表单样式
.search-form {
  background-color: var(--card-bg);
  padding: 15px;
  border-radius: 4px;
  margin-bottom: 15px;
  border: 1px solid var(--table-border);
}

// 金额文字样式
.amount-text {
  font-weight: 500;
  color: var(--text-sub);
}

.refund-text {
  color: var(--danger);
}

.sales-text {
  color: var(--accent);
  font-weight: 600;
}

.sales-highlight {
  color: var(--accent);
  font-weight: 600;
  font-size: 16px;
}

// 表格样式优化
::v-deep .el-table {
  .el-table__header {
    th {
      background-color: var(--table-header-bg);
      color: var(--table-header-text);
      font-weight: 600;
    }
  }

  .el-table__body {
    tr:hover {
      background-color: var(--table-row-hover);
    }
  }
}

// 分页样式
::v-deep .el-pagination {
  .el-pager li.active {
    background-color: var(--accent);
    color: white;
  }
}

// 响应式设计
@media (max-width: 768px) {
  .employee-info {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;

    .info-item {
      width: 100%;
      justify-content: space-between;
    }
  }
}

// 弹窗样式
.dialog-footer {
  text-align: right;
}

::v-deep .el-descriptions {
  .el-descriptions__label {
    font-weight: 600;
    background: var(--card-bg);
  }
}
</style>
